import React from "react";
import Marquee from "react-fast-marquee";

export default function TrademarkMarquee() {
  const text =
    "HIGH-RISK ALGORITHMS™ · EXPOSING THRONES OF INIQUITY · AWARENESS & DEFENSE · HIGHRISKALGORITHMS.COM · DO NOT IMITATE · DO NOT COPY ·";
  return (
    <div
      data-testid="trademark-marquee"
      className="bg-red-600 text-white py-6 border-y border-red-700"
    >
      <Marquee gradient={false} speed={55}>
        <div className="flex items-center gap-10 pr-10 font-mono text-xs md:text-sm uppercase tracking-[0.32em] font-bold">
          {Array.from({ length: 4 }).map((_, i) => (
            <span key={i} className="inline-flex items-center gap-10">
              {text}
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
